export default {
      id: "mail-usage",
      viewBox: "0 0 20 16",
      url: __webpack_public_path__ + "img/icons.c3436384.svg#mail",
      toString: function () {
        return this.url;
      }
    }